import React from 'react'
import { ClipboardTick } from 'iconsax-react'
import { useTheme } from '@mui/material'

import NotificationIcon from '../NotificationIcon'

const TaskNotificationIcon = () => {
  const theme = useTheme()
  return (
    <NotificationIcon>
      <ClipboardTick size={theme.size.lg} variant='Bulk' />
    </NotificationIcon>
  )
}

export default TaskNotificationIcon
